// src/components/Loader.jsx
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/Loading/AnimationSFG.json";

const Loader = ({ size = 120 }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Lottie
        animationData={loadingAnimation}
        loop
        autoplay
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default Loader;
